import { BRAND } from "constants/brand";
import { Ring } from "@uiball/loaders";
import "assets/styles/table.scss";
import { useSelector } from "react-redux";
import { useState, useRef } from "react";
import { Toast } from "primereact/toast";
import DeleteItem from "components/Ui/DeleteItem/DeleteItem";
import useArea from "hooks/useArea";
import Region from "./Region/Region";
import AddRegion from "./AddRegion/AddRegion";
import EditRegion from "./EditRegion/EditRegion";
import useCity from "hooks/useCity";
import { Form } from "react-bootstrap";
import TableColumnsMenu from "components/Ui/TableColumnsMenu/TableColumnsMenu";
import TableHead from "components/Ui/TableHead/TableHead";
import useTableColumnsConfig from "hooks/useTableColumnsConfig";

const COLUMNS = [
    { id: "id", label: "#", width: "10px" },
    { id: "name", label: "الاسم", width: "100px" },
    { id: "city", label: "المدينه", width: "100px" },
    { id: "location", label: "الموقع", width: "100px" },
    { id: "actions", label: "الاعدادات", width: "50px" },
];

const Regions = () => {
    const [showAddForm, setShowAddForm] = useState(false);
    const [showEditForm, setShowEditForm] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [selectedRegion, setSelectedRegion] = useState(null);
    const { loading, deleteArea } = useArea();
    const data = useSelector((state) => state.area.areas);
    const toast = useRef(null);
    const { cities } = useCity();
    const [city, setCity] = useState(null);
    const { orderedColumns, visibleColumns, hiddenSet, toggleColumn, moveColumn, reset } =
        useTableColumnsConfig("regions", COLUMNS);

    const showMessage = (type, head, content) => {
        toast.current.show({
            severity: type,
            summary: head,
            detail: content,
            life: 3000,
        });
    };

    const toggleAddForm = () => {
        setShowAddForm((pre) => (pre = !pre));
    };

    const toggleEditForm = () => {
        setShowEditForm((pre) => (pre = !pre));
    };

    const setSelectedRegionValue = (category) => {
        setSelectedRegion(category);
    };

    const toggleDelete = () => {
        setShowDelete((pre) => (pre = !pre));
    };

    const confirmDelete = async () => {
        try {
            const response = await deleteArea(selectedRegion.id);
            // Assuming `response` contains information to check if the operation succeeded

            if (response) {
                showMessage("warn", "تم الحذف", "تم حذف المنطقه بنجاح");
                toggleDelete();
            } else {
                showMessage("error", "هناك خطأ", "حدث خطأ غير متوقع");
            }
        } catch (err) {
            console.error("Error adding Area:", err);
            showMessage("error", "هناك خطأ", "حدث خطأ غير متوقع");
        }
    };

    return (
        <div className="items">
            <Toast style={{ direction: "rtl" }} ref={toast} position="top-left" />

            {loading ? (
                <div className="loadingSpinner">
                    <Ring size={40} lineWeight={5} speed={2} color={BRAND} />
                </div>
            ) : (
                <>
                    <div className="controls">
                        <div className="">
                            <Form.Select
                                onChange={(e) => {
                                    if (e.target.value === "") {
                                        setCity(null);
                                    } else {
                                        setCity(e.target.value);
                                    }
                                }}
                                value={city}
                                style={{
                                    marginBottom: "20px",
                                    maxWidth: "500px",
                                    minWidth: "300px",
                                }}
                            >
                                <option value={""}>الكل</option>
                                {cities?.map((user) => (
                                    <option key={user.id} value={user.id}>
                                        {user.name}
                                    </option>
                                ))}
                            </Form.Select>
                        </div>
                        <div>
                            <button className="button" onClick={toggleAddForm}>
                                إضافه منطقه
                            </button>
                        </div>
                        <div style={{ marginInlineStart: "auto" }}>
                            <TableColumnsMenu
                                orderedColumns={orderedColumns}
                                hiddenSet={hiddenSet}
                                toggleColumn={toggleColumn}
                                moveColumn={moveColumn}
                                reset={reset}
                            />
                        </div>
                    </div>

                    <div className="table-container">
                        <table>
                            <TableHead visibleColumns={visibleColumns} />
                            <tbody>
                                {data ? (
                                    data
                                        .filter((area) => {
                                            if (city) {
                                                return area.cityId === +city;
                                            } else {
                                                return true;
                                            }
                                        })
                                        .map((region) => (
                                            <Region
                                                key={region.id}
                                                region={region}
                                                visibleColumns={visibleColumns}
                                                selectedRegion={selectedRegion}
                                                toggleEditForm={toggleEditForm}
                                                setSelectedRegionValue={setSelectedRegionValue}
                                                toggleDelete={toggleDelete}
                                            />
                                        ))
                                ) : (
                                    <h4>لا يوجد مناطق!</h4>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <AddRegion
                        show={showAddForm}
                        close={toggleAddForm}
                        showMessage={showMessage}
                        cities={cities}
                    />
                    <EditRegion
                        show={showEditForm}
                        close={toggleEditForm}
                        showMessage={showMessage}
                        region={selectedRegion}
                        cities={cities}
                    />
                    <DeleteItem
                        show={showDelete}
                        close={toggleDelete}
                        loading={loading}
                        confirm={confirmDelete}
                    />
                </>
            )}
        </div>
    );
};
export default Regions;
